import {
    LOCATIONS_SUCCESS,
    LOCATIONS_FAILURE,
    LOCATIONS_REQUEST, LOCATIONS_POST_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const locationsReducer = (state = initialState, action) => {
    const {type, data, location} = action;
    switch (type) {
        case LOCATIONS_POST_SUCCESS: {
            return {
                ...state,
                data: [...state.data, location]
            }
        }

        case LOCATIONS_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case LOCATIONS_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case LOCATIONS_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
